export class ViewFamilyMemberCmConstants {
    static FAMILY_CONTROL = "family";
    static FAMILY_LABEL = "Family member";
    static COPY_APPLICANT_TO_FAMILY_LABEL = "Copy applicant to family";
    static DUPLICATE_APPLICANT_ERROR_MESSAGE = "This applicant already exists";
}
